
//---------------------------
//HERO CTA MESSAGE EXPERIMENT
//---------------------------
const isActiveHeroCTAMessageExp = false;
const heroBigCTA = document.querySelector('.hero-button');
const heroBigCTAClass = '.hero-button';

if (isActiveHeroCTAMessageExp && heroBigCTA) {
    const heroBigCTAExperimentId = heroBigCTA.getAttribute('data-experiment-id');

    if (heroBigCTAExperimentId) {
        gtag('event', 'optimize.callback', {
            name: heroBigCTAExperimentId,
            callback: heroCTAMessageExperiment
        });
    }
}

function heroCTAMessageExperiment(value) {
    if ('1' == value) {
        document.querySelectorAll(heroBigCTAClass).forEach(elem => {
            elem.style.display = 'none';

            if (elem.classList.contains('hero-button__variant')) {
                elem.style.display = 'block';
            }
        });
    }
}
